// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7":"159ffd79","16":"1f48e447","90":"6002fdd1","324":"4618b47b","495":"b7277b1f","820":"cc2b4fb4"}[chunkId] + ".chunk.css";
};